import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import CaseExtraSmallText from '../../../common-components/common-extra-small-text';

const functionalList = [
    {
        img: '/images/svg/tech-leaders/tech-leaders-functional__img1.svg',
        title: 'Фотобанк',
        text: 'Здесь фотографы могли в&nbsp;режиме реального времени заливать альбомы, пока шли секции. Фотографии сразу&nbsp;же разлетались по&nbsp;журналистам для публикации инфоповодов во&nbsp;всех федеральных СМИ. Так&nbsp;мы&nbsp;облегчили работу журналистам, которые могли работать еще оперативнее и&nbsp;не&nbsp;ждать фото для&nbsp;материалов о&nbsp;ходе форума.',
    },
    {
        img: '/images/svg/tech-leaders/tech-leaders-functional__img2.svg',
        title: 'Видеотрансляции',
        text: 'Мы разработали виджет, который за полчаса до&nbsp;трансляции запускал анонсы трансляций на сайте. Благодаря этому функционалу, на форуме мог присутствовать online любой гражданин страны, который&nbsp;интересуется ее развитием.',
    },
    {
        img: '/images/svg/tech-leaders/tech-leaders-functional__img3.svg',
        title: 'Аудиоэкскурсия города НТИ',
        text: 'Экскурсия на&nbsp;сайте форума, где можно прослушать информацию о&nbsp;каждом из&nbsp;российских высокотехнологичных решений, имеющих потенциал ответить на&nbsp;вызовы глобальной трансформации. К&nbsp;экскурсиям можно подключиться через QR-коды, которые были на&nbsp;рекламных стендах экспонентов.',
    },
    {
        img: '/images/svg/tech-leaders/tech-leaders-functional__img4.svg',
        title: 'Схема выставки',
        text: 'Разместили на&nbsp;сайте подробные схемы 2-х этажей со&nbsp;всеми экспонентами и&nbsp;их&nbsp;кратким описанием, чтобы&nbsp;участники форума не&nbsp;заблудились, даже если не&nbsp;нашли указатели.',
    },
    {
        img: '/images/svg/tech-leaders/tech-leaders-functional__img5.svg',
        title: 'Тестирование &laquo;дорожных карт&raquo;',
        text: 'Государство выделило 7&nbsp;ключевых направлений технологического развития. Основной задачей форума был стресс-тест дорожных карт со&nbsp;стороны экспертов. Мы&nbsp;реализовали сервис для доступа к&nbsp;необходимым для&nbsp;этого материалам.',
    },
];

const Functional = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="tech-leaders-functional" isMargin={false} smallPaddings={true}>
                <CommonSmallTitle className="tech-leaders-functional__title">
                    Функционал
                </CommonSmallTitle>
                <CommonSmallText className="tech-leaders-functional__subtitle">
                    Так как конференция посвящена глобальному технологическому лидерству страны,
                    сайт должен соответствовать по&nbsp;своему функционалу. Поэтому кроме
                    стандартных инструментов мы&nbsp;внедрили сложные технологические решения,
                    которые делают взаимодействие с&nbsp;сайтом проще:
                </CommonSmallText>
                <div className="tech-leaders-functional__list">
                    {functionalList.map(({ img, title, text }, index) => {
                        return (
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="tech-leaders-functional__item"
                                key={index}
                            >
                                <div className="tech-leaders-functional__title-container">
                                    <div className="tech-leaders-functional__img">
                                        <img src={img} alt="" loading="lazy" />
                                    </div>
                                    <CommonSmallText className="tech-leaders-functional__item-title">
                                        {parse(title)}
                                    </CommonSmallText>
                                </div>
                                <div className="tech-leaders-functional__text">
                                    <CaseExtraSmallText>{parse(text)}</CaseExtraSmallText>
                                </div>
                            </ScrollAnimation>
                        );
                    })}
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Functional;
